// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filters input, .filters select {
    width: 100%;
    padding: 6px;
    margin-top: 4px;
    box-sizing: border-box;
}

th, td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
}

th {
    background-color: #f2f2f2;
}

.pagination button {
    margin-right: 5px;
    padding: 5px 10px;
}

    .pagination button.active {
        background-color: #007bff;
        color: white;
    }
`, "",{"version":3,"sources":["webpack://./src/pages/demo/PortCall/PortCallListPage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;IAEI;QACI,yBAAyB;QACzB,YAAY;IAChB","sourcesContent":[".filters input, .filters select {\n    width: 100%;\n    padding: 6px;\n    margin-top: 4px;\n    box-sizing: border-box;\n}\n\nth, td {\n    border: 1px solid #ccc;\n    padding: 8px;\n    text-align: left;\n}\n\nth {\n    background-color: #f2f2f2;\n}\n\n.pagination button {\n    margin-right: 5px;\n    padding: 5px 10px;\n}\n\n    .pagination button.active {\n        background-color: #007bff;\n        color: white;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
